import React from "react";
import { WirderMark } from "./wirderMark";

export interface HomeBrandProps {
  /**
   * Extra class(es) for the logo `img`, layered on top of `home__logo`. The
   * connecting screen uses this to add its fly-in animation while keeping the
   * exact resting geometry, so the hand-off to Home is seamless.
   */
  logoClassName?: string;
}

/**
 * The Home brand header: mascot + "Wirder" wordmark + definition. Shared by
 * {@link HomeScreen} and the connecting screen so the two headers never drift
 * and the launch animation lands the logo exactly where Home will render it.
 */
export function HomeBrand({ logoClassName }: HomeBrandProps) {
  const logoClass = logoClassName ? `home__logo ${logoClassName}` : "home__logo";
  return (
    <div className="home__brand">
      <WirderMark className={logoClass} />
      <div className="home__brand-text">
        <div className="display home__word">Wirder</div>
        <div className="home__defn">
          <span className="home__defn-head">
            <span className="pron">(wer&middot;der)</span> <span className="pos">n.</span>
          </span>
          <span className="home__defn-body">A bird with a passion for finding rare words.</span>
        </div>
      </div>
    </div>
  );
}
